import React, { createContext, useContext, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const InactivityContext = createContext();

export const InactivityProvider = ({ children }) => {
  const timeoutRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const isAuthenticated = () => {
    return !!localStorage.getItem("authToken");
  };

  const logoutUser = () => {
    alert("Session expired due to inactivity.");
    localStorage.clear();

    navigate("/login-1", { replace: true });
    window.history.pushState(null, "", window.location.href);
  };

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(logoutUser, 10 * 60 * 1000);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click"];
    const handleActivity = () => {
      if (location.pathname !== "/login-1") {
        resetTimeout();
      }
    };

    events.forEach((event) => window.addEventListener(event, handleActivity));

    if (location.pathname !== "/login-1") {
      resetTimeout();
    }

    return () => {
      clearTimeout(timeoutRef.current);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity)
      );
    };
  }, [location.pathname]);

  useEffect(() => {
    const handlePopState = () => {
      if (!isAuthenticated()) {
        navigate("/login-1", { replace: true });
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <InactivityContext.Provider value={{ resetTimeout }}>
      {children}
    </InactivityContext.Provider>
  );
};

export const useInactivity = () => useContext(InactivityContext);
